import { connect } from "react-redux";
import { ThunkDispatch } from "@reduxjs/toolkit";

import { ApplicationState } from "../../../redux/ApplicationState";
import AdminPortal from "../components/AdminPortal";
import { getMasterHealthPlan, getMasterRole, getMasterServiceProvider } from "../../../actions/Master";
import { getListResult } from "../../../utils";
import { getAdminSelectedUserByEmail, getPortalUpdate, postAdminUserList } from "../../../actions/AdminActions";
import { UserListPayload, UserPageTrack } from "../../../models/User";
import { getMfaPreference } from "../../../actions/MyAccount";
import { resetStates } from "../../../actions/Common";
import { postUserPageTrack } from "../../../actions/UserAction";

const mapStateToProps = ({
  masterMfaPreferenceState,
  updateUserDetailsState,
  loggedInUserState,
  masterRoleState,
  masterServiceProviderState,
  userListState,
  addUserState,
  addPortalUpdateState,
  getActivateDeActivateUserState
}: ApplicationState) => ({
  masterMfaPreferenceState:
  masterMfaPreferenceState.response,
  updateUserDetailsState: updateUserDetailsState.response,
  updateUserDetailsLoading: updateUserDetailsState.loading,
  loggedInUser: loggedInUserState.response,
  masterRoleState: getListResult(masterRoleState.response),
  masterServiceProviderState: getListResult(masterServiceProviderState.response),
  userListState: userListState.response,
  userListLoading: userListState.loading,
  addUserState: addUserState.response,
  portalUpdate: addPortalUpdateState.response,
  getActivateDeActivateUserState: getActivateDeActivateUserState.response
});

const mapDispatchToProps = (
  dispatch: ThunkDispatch<ApplicationState, Record<string, never>, any>
) => {
  return {
    getMasterRole: () => {
      dispatch(getMasterRole());
    },
    getMasterServiceProvider: () => {
      dispatch(getMasterServiceProvider());
    },
    postAdminUserList: (payload: UserListPayload) => {
      dispatch(postAdminUserList(payload));
    },
    getMfaPreference: () => {
      dispatch(getMfaPreference());
    },
    resetStates: (actionType: string) => {
      dispatch(resetStates(actionType));
    },
    getPortalUpdate: () => {
      dispatch(getPortalUpdate());
    },
    getAdminSelectedUserByEmail: (userEmail: string) => {
      dispatch(getAdminSelectedUserByEmail(userEmail));
    },
    postUserPageTrack: (payload: UserPageTrack) => {
      dispatch(postUserPageTrack(payload));
    },
    getMasterHealthPlan: () => {
      dispatch(getMasterHealthPlan());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AdminPortal);
